export const RECENT = { label: "최신순", value: "createdAt" };
export const LIKE = { label: "공감순", value: "likes" };
export const SCORE = { label: "점수순", value: "score" };
